import { FormGroup, Label, Input, Row, Col, Button, FormFeedback } from 'reactstrap'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import '../ManualUploads.css'
import { Controller } from 'react-hook-form'
interface CollectionOption {
  value: string
  label: string
}

const ManualUploadsCollectionIds = ({
  name,
  id = `${name}Input`,
  control,
  errors,
  defaultValue = [65535],
  placeholder = 'Select Collection Id(s)...',
  setValue,
  visible
}) => {
  const dispatch = useDispatch()
  const [checkSelected, setCheckSelected] = useState<boolean>(false)
  const [checkedSelectAll, setCheckedSelectAll] = useState<boolean>(false)
  const [disabledOption, setDisabledOption] = useState<any[]>([])
  const collectionIds: CollectionOption[] = Array.from({ length: 16 }, (_, i) => ({
    value: String(2 ** i),
    label: String(i + 1)
    }));

  const handleFilter = (checked) => {
    if (checked == false) {
      setDisabledOption([])
      setValue('collectionIds', [65535])
    } else {
      setDisabledOption([])
      setValue('collectionIds', [])
    }
  }

  const handleSelect = (e) => {
    setDisabledOption([...e.target.options].filter((option) => option.selected))
    const updatedOptions = [...e.target.options]
      .filter((option) => option.selected)
      .map((x) => x.value)
    return updatedOptions
  }

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setCheckedSelectAll(true)
      setDisabledOption(collectionIds)
      const allVals = collectionIds.map((x) => x.value)
      setValue('collectionIds', allVals)
    } else {
      setCheckedSelectAll(false)
      setValue('collectionIds', [])
    }
  }

  const handleDeselect = (e, value) => {
    const updatedOptions = value.filter((option) => option != e.target.value)
    setDisabledOption([...disabledOption].filter(option => option.value != e.target.value))
    setCheckedSelectAll(false)
    setValue('collectionIds', updatedOptions)
  }

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({
        field: { onChange, onBlur, value, name, ref }      
      }) => {
        return (
          <FormGroup className='form-control collection-ids'>
            <Row className='manual-uploads-row'>
              <Col className='manual-uploads-col' style={{ padding: '0px' }}>
                <FormGroup className='collections-checkbox-group'>
                  <Input
                    type='checkbox'
                    className='collections-checkbox'
                    checked={checkSelected}
                    onChange={(e) => {
                      setCheckSelected(e.target.checked)
                      setCheckedSelectAll(!e.target.checked)
                      handleFilter(e.target.checked)
                    }}
                  />{' '}
                  <Label
                    check
                    className='collections-checkbox-label manual-uploads-label'
                  >
                    Filter by Collection ID(s)
                  </Label>
                </FormGroup>
                {checkSelected && (
                  <FormGroup style={{margin:'0px'}}>
                    <Label for='collection_ids' className='hidden'>
                      Collection IDs
                    </Label>
                    <Row>
                    {disabledOption.map((option, index) => {
                        return(<Button key={index} id='disabled_option' value={option.value} onClick={(e) => handleDeselect(e, value)} className={
                          value.includes(option.value)
                            ? ''
                            : 'hidden'
                        }>{option.label}</Button>)
                      })}
                    </Row>
                    <Input
                      id='collection_ids'
                      multiple
                      name={name}
                      type='select'
                      value={value}
                      onChange={(e) => {
                        onChange(handleSelect(e))
                      }}
                      onBlur={onBlur}
                      ref={ref}
                      style={{ padding: '0', overflowY: 'scroll' }}
                      size={6}
                    >
                      <option
                        disabled
                        style={{
                          textAlign: 'center',
                          borderBottom: 'solid 1px grey'
                        }}
                      >
                        ----- ctrl + click to select more than one -----
                      </option>
                      {collectionIds.map((option, index) => {
                        return (
                          <option
                            key={index}
                            value={option.value}
                            className={
                              value.includes(option.value)
                                ? 'collections-options selected'
                                : 'collections-options'
                            }
                          >
                            {option.label}
                          </option>
                        )
                      })}
                    </Input>
                    <FormFeedback
                       valid={errors?.[name] ? false : true}
                       role='alert'
                       id={`${name}Error`}
                       style={visible ? {display:'block'} : {display: 'hidden'}}
                      >
                        {errors?.[name]?.message}
                    </FormFeedback>
                    <Row className='collections-select-reset-group'>
                      <FormGroup className='collections-checkbox-group' style={{margin:'0px'}}>
                        <Input
                          type='checkbox'
                          className='collections-select-all'
                          checked={checkedSelectAll}
                          value={value}
                          onChange={(e) => {
                            handleSelectAll(e)
                          }}
                        />{' '}
                        <Label
                          check
                          className='collections-select-all-label manual-uploads-label'
                        >
                          Select All
                        </Label>
                      </FormGroup>
                    </Row>
                  </FormGroup>
                )}
              </Col>
            </Row>
          </FormGroup>
        )
      }}
    />
  )
}

export default ManualUploadsCollectionIds
